<template lang="pug">
#Results
  SchoolInfo(
        v-for="(school, i) in fullListings"
        :school="school"
        :isZonedSchool="isZonedSchool"
        :zonedSchoolCount="(fullListings|| []).length"
        :zonedSchoolPos="i"
  )
  //- SchoolInfo(:school="zonedSchool" :zonedEntityCode="zonedEntityCode")
  ExportButton.only-screen

  div(style="margin-bottom: 30px")
  OtherZonedSchools(:schools="shortListings")
  NearestSchools
  Disclaimer(v-show="hasAddressQuery()")

</template>

<script>
import SchoolInfo from '@/components/SchoolInfo.vue';
import NearestSchools from '@/components/NearestSchools.vue';
import OtherZonedSchools from '@/components/OtherZonedSchools.vue';
import Disclaimer from '@/components/Disclaimer.vue';
import { EventBus } from './EventBus';
import ExportButton from './ExportButton.vue';

function filterUniqueSchools(schools) {
    return schools;
    return schools.filter(
        (school, i, self) =>
            self.findIndex(
                s => !school || (s && s.Entity_Code === school.Entity_Code)
            ) === i
    );
}

export default {
    name: 'Results',
    components: {
        SchoolInfo,
        NearestSchools,
        OtherZonedSchools,
        Disclaimer,
        ExportButton,
    },
    data: () => ({
        selectedSchool: undefined,
        zonedSchools: undefined,
        shortListings: undefined,
        fullListings: undefined,
        zonedEntityCode: undefined, // the code for the school that matched the last address they provided
        isZonedSchool: undefined,
    }),

    created() {
        window.app.Results = this;
        EventBus.$on(
            'school-select',
            (school, zoomTo, { isZoned, schools } = {}) => {
                this.selectedSchool = school;
                this.isZonedSchool = !!isZoned;
                // if (isZoned) {
                //     this.zonedEntityCode = school.properties.Entity_Code;
                // }
                if (schools) {
                    this.zonedSchools = schools;
                } else {
                    this.zonedSchools = school ? [school] : [];
                }
                const noQuery = this.zonedSchools.every(
                    school => !school.properties.queryMatch
                );
                // see #193
                const showFull = s =>
                    noQuery ||
                    s.properties.isStandalone ||
                    s.properties.queryMatch === 'exact';

                this.fullListings =
                    this.zonedSchools &&
                    filterUniqueSchools(this.zonedSchools.filter(showFull));
                this.shortListings =
                    this.zonedSchools &&
                    filterUniqueSchools(
                        this.zonedSchools.filter(s => !showFull(s))
                    );
            }
        );
    },
    watch: {
        school() {
            this.$emit('schoolChanged', this.zonedSchool);
        },
        selectedSchool() {
            this.updateHash();
        },
    },

    methods: {
        hasAddressQuery() {
            return !!(
                window.app.AddressSearch &&
                window.app.AddressSearch.addressQuery
            );
        },
        async updateHash() {
            // if (!this.hashLoaded) {
            //     return;
            // }
            // const school = window.app.SchoolInfo.selectedSchool;
            if (this.selectedSchool) {
                if (window.location.hostname !== 'laoeocalhost') {
                    window.location.hash = `school=${this.selectedSchool.properties.Entity_Code}`;
                }
            } else {
                window.location.hash = '';
            }
        },
    },
};
</script>

<style scoped></style>
